import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { SharedService } from '../../../app/services/shared.service';
import { DashboardService } from 'src/app/api/services/dashboard.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {

  constructor(
    private msalService: MsalService,
    private router: Router,
    private readonly sharedService: SharedService,
    private dashboardService: DashboardService
  ) { }

  ngOnInit(): void {
    const isLogged = !!this.msalService.instance.getAllAccounts()[0];
    if (isLogged) {
      this.dashboardService.getRole().subscribe(
        res => {
          this.sharedService.setRoleUser(res);
          this.router.navigateByUrl('/home');
        },
        err => {
          console.log(err);
          this.sharedService.goToNotAuthorizedPage('login.component.ts - getRole().error');
        }
      )
    }
  }
}
